import { render, staticRenderFns } from "./EchartsBarTnbXf.vue?vue&type=template&id=647f7c1e&scoped=true&"
import script from "./EchartsBarTnbXf.vue?vue&type=script&lang=js&"
export * from "./EchartsBarTnbXf.vue?vue&type=script&lang=js&"
import style0 from "./EchartsBarTnbXf.vue?vue&type=style&index=0&id=647f7c1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647f7c1e",
  null
  
)

export default component.exports